/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlRelationshipsQueryVariables = Types.Exact<{
  matterId: Types.Scalars["String"]["input"];
  roleId: Types.Scalars["String"]["input"];
}>;

export type GqlRelationshipsQuery = {
  __typename: "Query";
  relationships: Array<{
    __typename: "Relationship";
    id: string;
    name: string;
    contactId?: string | null;
    representativeIds?: Array<string> | null;
  }>;
};

export const RelationshipsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "relationships" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roleId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "relationships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roleId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "relationshipFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relationshipFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relationship" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "representativeIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlRelationshipsQuery,
  GqlRelationshipsQueryVariables
>;
